import React, { useState, useContext, useEffect } from "react";
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import { useNavigate } from 'react-router-dom';

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { LoginContext } from "../page/contexts/LoginContext";
import Cookies from 'js-cookie';

const ITEM_HEIGHT = 48;

export default function LongUser() {
    const navigate = useNavigate();
    const {
        setLogin,
        setListchilden,

        setListgl,

    } = useContext(LoginContext);

    const [isHovered, setIsHovered] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);


    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleSignOut = () => {
        // localStorage.clear(); // Clear all data
        // setLogin(false)
        // setListchilden([])
        // setListgl({})
        // navigate('/')
        Cookies.remove('user')
        window.location.assign('https://psvsystem.com/');
    };

    return (
        <div>
            <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
            >
                <AccountCircleIcon style={{ color: 'white' }} />
            </IconButton>
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '40ch',
                        marginTop: 50
                    },
                }}
            >
                <div style={{
                    width: 300,
                    backgroundColor: "#fff",
                    borderRadius: 8,
                    padding: 16,
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 16,
                        flexDirection: 'column'

                    }}>
                        <div style={{
                            width: 50,
                            height: 50,
                            borderRadius: '50%',
                            backgroundColor: '#0077c5',
                            color: '#fff',
                            fontSize: 24,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: 10,
                            cursor: 'pointer'

                        }}

                        >
                            {/* {localStorage.getItem('company_name')[0]} */}
                            P

                        </div>
                        <h3 style={{ fontSize: 18, margin: 0, color: '#333' }}>PSVB</h3>
                        <button
                            style={{
                                width: '100%',
                                padding: 10,
                                backgroundColor: '#f5f5f5',
                                border: 'none',
                                borderRadius: 4,
                                color: '#333',
                                fontSize: 14,
                                cursor: 'pointer',
                                marginTop: 20,
                                backgroundColor: isHovered ? '#e0e0e0' : '#f5f5f5',
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            onClick={() => { handleSignOut() }}

                        >Sign out</button>
                    </div>

                </div>

            </Menu>
        </div>
    );
}
